export default __webpack_public_path__ + "static/out_sourcing.3-5cbf846af56abd0056272d0416fb5358.jpg";